const Benefits = () => import(/* webpackChunkName: "Benefits" */ "@/views/benefits/Benefits");
const BenefitsList = () => import(/* webpackChunkName: "Benefits List" */ "@/views/benefits/BenefitsList");
const BenefitsNew = () => import(/* webpackChunkName: "Benefits New" */ "@/views/benefits/BenefitsNew");

const benefitsRoutes = [
  {
    path: "benefits",
    name: "Benefits",
    redirect: {
      name: "Benefits List"
    },
    component: Benefits,
    children: [
      {
        path: "list",
        name: "Benefits List",
        component: BenefitsList
      },
      {
        path: "new",
        name: "Benefits New",
        component: BenefitsNew
      },
      {
        path: "edit/:id",
        name: "Benefits Edit",
        component: BenefitsNew,
        props: true
      }
    ]
  }
];

export default benefitsRoutes;